import React from 'react';
import { Container, ContainerProps } from "react-bootstrap";

export const Layout = (props: ContainerProps) => (
    <Container className="alhCore">
        {props.children}
    </Container>
)
